
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import {Ontotis } from '../../../utils/types';
import Pagination from '../../../components/Pagination';
import OntotitesList from './ontititesList';
import { getOntotisAllList } from '../../../utils/apicall/ontotisApi';
import { handleError, ApiError } from '../../../utils/error/error';
import NotFound from '../../common/404';
import GeneralErrorPage from '../../common/general-error';
import { authService } from '../../../utils/authServices';


const OntotitesDashboard: React.FC  = ( ) => {
  const [data, setData] = useState<Ontotis[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>(''); // State for the search input
  const [currentPage, setCurrentPage] = useState(1);
  const itemPerPage = 15;
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const [isValidPath, setIsValidPath] = useState(true);
  
  const loadData = useCallback(async () => {
    try {
    const response = await getOntotisAllList();
   //  console.log({response});
      if (response) {
        setData(response);
      //  console.log(response);
      } else {
        console.warn('Expected an array but got:', response);
      }
    } catch (error) {
      handleError(error);
            if (error instanceof ApiError && error.statusCode === 404) {
                setIsValidPath(false);
            } else {
                console.error('An unexpected error occurred:', error);
                return <GeneralErrorPage />;
            }
  
    }

  }, []);
 // Render 404 page if the path is invalid or no data is found

  useEffect(() => {
    loadData();
    authService.refreshAuthToken();
 //  console.log(data);
  }, [loadData]);

  // Apply search filter
  const filteredData = useMemo(() => {
    return data.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [data, searchTerm]);

  // Sort logic
  const sortedData = useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        let aValue: any;
        let bValue: any;

        switch (sortConfig.key) {
          case 'title':
            aValue = a.title?.trim().toLowerCase() ?? '';
            bValue = b.title?.trim().toLowerCase() ?? '';
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig]);

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Sorting functions
  const requestSort = (key: 'title' ) => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const totalPages = Math.ceil(sortedData.length / itemPerPage);

  // Determine title
  const title = "Οντότητες"; 

  if (!isValidPath) {
    return <NotFound />;
  }
  return (
    <div className="content">
     <section className="ontotita py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-7">
            <h2 className="h4 text-primary fw-light py-3">{title}</h2>
          </div>
        </div>
          {/* Search and Sort Controls */}
          <div className="row align-items-center">
            {/* <!-- Search Input --> */}
            <div className="col-md-9 mb-4">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Αναζήτηση ..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
             </div>
          {/* Sort Buttons */}
          <div className="col-md-3 mb-4 text-md-end">
            <button onClick={() => requestSort('title')} className="btn btn-primary btn-sm">
              Ταξινόμηση/Τίτλος
              </button>
           
          </div>
        </div>
        <div className="row">
                <div className="col-12">
                   <hr className="" style={{ borderColor: "#036EC5" }} />
                </div>
            </div>
              
        <div id="projectList">
          <OntotitesList data={sortedData.slice((currentPage - 1) * itemPerPage, currentPage * itemPerPage)} />
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      </section>
    </div>

  );
};

export default OntotitesDashboard;
